import { render, staticRenderFns } from "./ManageDiagnosticModal.vue?vue&type=template&id=691faa98"
import script from "./ManageDiagnosticModal.vue?vue&type=script&lang=js"
export * from "./ManageDiagnosticModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports